import React from 'react';

const HomeGymLandingPage = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>🏋️‍♂️ Welcome to HomeGym AI</h1>

      {/* YouTube Video Embed */}
      <div style={styles.videoContainer}>
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/xXuGWfbTQ64"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      {/* Download Button */}
      <a
        href="https://drive.google.com/file/d/1MwZTjgdIxPdY9WHJtfQLP7frILK0uRg_/view?usp=sharing"
        download
        style={styles.downloadButton}
      >
        💾 Download Desktop App (530MB)
      </a>

      {/* Play Store Link */}
      <a
        href="https://drive.google.com/file/d/1VW1mYnt6cmJIAAO8LwUIlNqNIEtVIVY7/view?usp=sharing"
        target="_blank"
        rel="noopener noreferrer"
        style={styles.playstoreButton}
      >
        📲 Download Android App
      </a>
    </div>
  );
};

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '800px',
    margin: 'auto',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
  },
  heading: {
    marginBottom: '2rem',
  },
  videoContainer: {
    marginBottom: '2rem',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  downloadButton: {
    display: 'inline-block',
    margin: '1rem',
    padding: '1rem 2rem',
    backgroundColor: '#007bff',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: 'bold',
  },
  playstoreButton: {
    display: 'inline-block',
    margin: '1rem',
    padding: '1rem 2rem',
    backgroundColor: '#34A853',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: 'bold',
  },
};

export default HomeGymLandingPage;
